import { render } from "./AgentLayout.vue?vue&type=template&id=28727e56&scoped=true"
import script from "./AgentLayout.vue?vue&type=script&lang=js"
export * from "./AgentLayout.vue?vue&type=script&lang=js"

import "./AgentLayout.vue?vue&type=style&index=0&id=28727e56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28727e56"]])

export default __exports__